export default {
  liveDataSummary: 'Requests change live data',
  liveDataDetails: 'Every request you send here acts on live data with your permissions. Changes and deletions take effect immediately and can\'t be undone.',
};
